import * as React from 'react';
import "./AlertNotificationBell.scss";
import { AlertNotification } from 'webportalclient';
import { DateTimeAccuracy, LocalizedDateTime } from '../misc/components/LocalizedDateTime';
import { useWebPortalApiClient } from '../misc/api/WebPortalTokenClient';

interface NotificationModalDetailProps {
    alert: AlertNotification;
    visible: boolean;
    onClose: () => void;
}

export const NotificationModalDetail = (props: NotificationModalDetailProps) => {
    const client = useWebPortalApiClient();

    const handleMarkAsRead = async () => {
        await client.client.patchAlertNotification({
            isRead: true,
        }, props.alert.id);
        props.onClose();
    }


    if (props.visible) {
        return (
            <>
                <div className="row">
                    <div className="col-sm-12">
                        <a style={{ padding: 0 + 'px', cursor: 'pointer' }} onClick={() => props.onClose()}>Back To Summary</a> |
                        <a style={{ padding: 0 + 'px', cursor: 'pointer' }} onClick={handleMarkAsRead}>Mark As Read</a>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="panel panel-default">
                            <div className="panel-body">
                                <h4>{props.alert.alert.headline}</h4>
                                {props.alert.alert.content}
                            </div>
                            <div className="panel-footer">
                                Alert Triggered at: <LocalizedDateTime time={props.alert.alert.occurred} accuracy={DateTimeAccuracy.Second} />
                            </div>
                        </div>
                    </div>
                </div>  
            </>
        );
    }
    else {
        return null;
    }
}
